import React from 'react';
import { Trans } from 'react-i18next';
import formatMessageWrapper from '~/utils/format-message-wrapper/format-message-wrapper';
import * as S from './styled';

export interface Props {
  langKey: string;
}

const OptionalLegendRenderer: React.FC<Props> = (props) => {
  const translation = formatMessageWrapper(props.langKey);
  if (props.langKey === translation || translation === '') {
    return null;
  }
  return (
    <>
      <S.SliderPageLegendContentDiv>
        <Trans i18nKey={props.langKey} />
      </S.SliderPageLegendContentDiv>
      {props.children}
    </>
  );
};

export default OptionalLegendRenderer;
